<div fxLayout="column" ngStyle.xs="max-height:77vh">
  <span fxLayout="row" class="div-header">
    <span fxFlex fxLayoutAlign="center center" fxLayout="row">
      <span class="heading medium" ngClass.xs="heading xs medium">{{
        data.status
      }}</span>
    </span>
  </span>

  <mat-dialog-content>
    <div
      *ngIf="data.checkOut"
      fxLayout="column"
      class="div-content"
      ngClass.xs="div-content-xs"
    >
      <img
        class="checkOutImage"
        (load)="setLoaded()"
        alt="banner"
        fxHide.xs="true"
        [src]="desktopImage"
        height="100%"
        width="100%"
      />
      <img
        class="checkOutImage"
        (load)="setLoaded()"
        alt="banner"
        fxHide.xs="false"
        fxHide="true"
        [src]="mobileImage"
        height="100%"
        width="100%"
      />
    </div>
    <div
      *ngIf="!data.checkOut"
      fxLayout="column"
      class="div-content"
      ngClass.xs="div-content-xs"
    >
      <img
        alt="banner"
        (load)="setLoaded()"
        [src]="checkInDesktopImage"
        fxHide.xs="true"
        height="100%"
        width="100%"
      />
      <img
        alt="banner"
        (load)="setLoaded()"
        [src]="checkInMobileImage"
        fxHide.xs="false"
        fxHide="true"
        height="100%"
        width="100%"
      />
    </div>
    <div
      *ngIf="imageLoading"
      fxLayout="column"
      fxLayoutAlign="center center"
      style="width: 600px; height: 350px"
      ngStyle.xs="width: 300px; height: 500px"
    >
      <mat-spinner
        diameter="35"
        mode="indeterminate"
        color="primary"
      ></mat-spinner>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="column" fxLayoutAlign="center center">
    <span fxLayout="row" style="padding-bottom: 30px; padding-top: 10px">
      <button
        color="primary"
        mat-stroked-button
        ngStyle.xs="width:100px"
        class="ok-button medium"
        (click)="ok()"
      >
        {{ "ok" | transloco }}
      </button>
    </span>
  </mat-dialog-actions>
</div>
